function sameId(left, right) {
  return left != null && right != null && String(left) === String(right);
}

function embeddedSet(activity, setId) {
  for (const exercise of activity?.data?.exercises || []) {
    const set = (exercise.sets || []).find(candidate => sameId(candidate._id, setId));
    if (set) return set;
  }
  return null;
}

export function deriveCircuitPosition(activity, nowMs = Date.now(), options = {}) {
  const steps = activity?.data?.ai_supervision?.circuit?.steps || [];
  const workIndex = steps.findIndex(step => step.kind === 'work' && !embeddedSet(activity, step.workout_set_id)?.complete);
  if (workIndex < 0) return { kind: 'complete', stepIndex: steps.length };

  const precedingRest = steps[workIndex - 1];
  const precedingWork = steps[workIndex - 2];
  if (precedingRest?.kind === 'rest' && precedingWork?.kind === 'work') {
    const completedAt = new Date(embeddedSet(activity, precedingWork.workout_set_id)?.completed_at).getTime();
    if (Number.isFinite(completedAt)) {
      const remainingMs = completedAt + (precedingRest.duration_seconds * 1000) - nowMs;
      if (remainingMs > 0) {
        return {
          ...precedingRest,
          stepIndex: workIndex - 1,
          remainingSeconds: Math.ceil(remainingMs / 1000),
        };
      }
    }
  }

  const workStep = { ...steps[workIndex], stepIndex: workIndex };
  let workStartedAt = Number.isFinite(options.workSessionStartedAtMs)
    ? options.workSessionStartedAtMs
    : (workIndex === 0 ? new Date(activity?.started_at).getTime() : NaN);
  if (!Number.isFinite(options.workSessionStartedAtMs) && workIndex >= 2 && precedingRest?.kind === 'rest' && precedingWork?.kind === 'work') {
    const previousCompletedAt = new Date(embeddedSet(activity, precedingWork.workout_set_id)?.completed_at).getTime();
    if (Number.isFinite(previousCompletedAt)) workStartedAt = previousCompletedAt + (precedingRest.duration_seconds * 1000);
  }
  if (Number.isFinite(workStartedAt) && Number.isFinite(workStep.max_duration_seconds)) {
    workStep.remainingSeconds = Math.max(0, Math.ceil((workStartedAt + (workStep.max_duration_seconds * 1000) - nowMs) / 1000));
  }
  return workStep;
}

export function createSetCompletionGate() {
  const inFlight = new Map();
  const completed = new Map();
  return {
    run(setId, operation) {
      const key = String(setId);
      if (completed.has(key)) return Promise.resolve(completed.get(key));
      if (inFlight.has(key)) return inFlight.get(key);
      const promise = Promise.resolve()
        .then(operation)
        .then(value => {
          completed.set(key, value);
          inFlight.delete(key);
          return value;
        })
        .catch(error => {
          inFlight.delete(key);
          throw error;
        });
      inFlight.set(key, promise);
      return promise;
    },
    hasCompleted(setId) {
      return completed.has(String(setId));
    },
  };
}
